import { render, staticRenderFns } from "./LostAndFound.vue?vue&type=template&id=68841758"
import script from "./LostAndFound.vue?vue&type=script&lang=js"
export * from "./LostAndFound.vue?vue&type=script&lang=js"
import style0 from "./LostAndFound.vue?vue&type=style&index=0&id=68841758&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports